import React from 'react';
import styles from './genericTable.less';
export function NoRows(_a) {
    var isLoading = _a.isLoading;
    return (React.createElement(React.Fragment, null, !isLoading && React.createElement("div", { className: styles.message }, "No rows found. Please change search or filtering criteria.")));
}
